import api, { reportingDevUrl, walletApi } from "../api";

const ReportsModule = () => {
  return {
    ListTransaction: function (data) {
      return api.post("wallet/Wallet/walletwithdownlinetransactions", data);
    },

    AgentListTransaction: function (data) {
      return api.post("wallet/Wallet/downline/wallettransactions", data);
    },

    TransactionDetails: function (data) {
      return api.post(`/Admin/reports/airtime/${data?.ref}`, data);
    },

    MainWallet: function (data) {
      return reportingDevUrl.get(
          `/Wallet/wallet-transactions?PageSize=${data?.pageSize}&PageNumber=${data?.pageNumber}&WalletId=${data?.walletId}&StartDate=${data.startDate}&EndDate=${data.endDate}&SearchText=${data.search}`
      );
    },

    MainWalletDownline: function (data) {
      return reportingDevUrl.get(
          `/Wallet/customers-downline-transactions?PageSize=${data?.pageSize}&PageNumber=${data?.pageNumber}&WalletId=${data?.walletId}&StartDate=${data.startDate}&EndDate=${data.endDate}&SearchText=${data.search}`
      );
    },

    CommissionWalletReport: function (data) {
      return reportingDevUrl.get(
          `/Wallet/commission-transactions?PageSize=${data?.pageSize}&PageNumber=${data?.pageNumber}&WalletId=${data?.walletId}&StartDate=${data.startDate}&EndDate=${data.endDate}&SearchText=${data.search}`
      );
    },

    AirtimeReports: function (data) {
      //console.log("data new stuff", data);
      return api.get(
        // `/wallet/Wallet/commissionmovements?PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&keyword=${data.keyword}&ServiceType=${data.ServiceType}&StartDate=${data.startDate}&EndDate=${data.endDate}`
        `airtime/Airtime/airtimetransactions?PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&SearchText=${data.keyword}&Network=${data.network}&StartDate=${data.startDate}&EndDate=${data.endDate}&TransactionStatus=${data.transactionStatus}&includeDownline=true`
        // ?SearchText=""&TransactionStatus=2&Network=2&PageSize=10&CurrentPage=1&CurrentPageIndex=1&StartDate=2021-01-01&EndDate=2022-09-30
        // `
      );
    },

    BillsReports: function (data) {
      //console.log("data new stuff", data);
      return walletApi.get(
        `Transaction/bills-transactions?PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&SearchText=${data.keyword}&TransactionType=${data.network}&StartDate=${data.startDate}&EndDate=${data.endDate}&TransactionStatus=${data.transactionStatus}&IncludeDownline=true`
      );
    },

    DataReports: function (data) {
      return api.get(
        `data/Service/datatransactions?PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&SearchText=${data.keyword}&Network=${data.network}&StartDate=${data.startDate}&EndDate=${data.endDate}&TransactionStatus=${data.transactionStatus}&includeDownline=true`
      );
    },

    CusstomerListing: function (data) {
      console.log("data new stuff", data);
      return api.get(
        `identity/Agent/customerlisting?AgentRoleId=${data.agentrole}&PageSize=${data.pageSize}&CurrentPage=${data.currentPage}&StartDate=${data.startDate}&EndDate=${data.endDate}`
      );
    },

    SingleCustomerListing: function (data) {
      return api.get(`identity/Agent/downline/details?walletId=${data}`);
    },

    GetTransactionReciept: function (txRef) {
      return walletApi.get(`Transaction/transaction-receipt/${txRef}`);
    },

    TransactionSummary: function (data) {
      // //console.log("data2", data);
      const { startDate, endDate, service_code, currentPage, pageSize } = data;
      return api.get(
        `wallet/Wallet/report/service/summary?startDate=${startDate}&endDate=${endDate}&service_code=${service_code}&CurrentPage=${currentPage}&PageSize=${pageSize}`
      );
    },
  };
};

export const ReportsService = {
  reportsModule: ReportsModule,
};
